import { useEffect, useState } from "react";

// Animated SVG donut showing a score out of /10.
export default function ScoreDonut({ score = 0, max = 10, testId }) {
  const [progress, setProgress] = useState(0);
  const target = Math.max(0, Math.min(max, Number(score) || 0)) / max;
  const r = 36;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - progress);

  useEffect(() => {
    // animate in
    const t = setTimeout(() => setProgress(target), 80);
    return () => clearTimeout(t);
  }, [target]);

  return (
    <div className="score-donut" data-testid={testId}>
      <svg viewBox="0 0 84 84">
        <circle cx="42" cy="42" r={r} className="track" />
        <circle
          cx="42" cy="42" r={r}
          className="fill"
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="center">
        <div className="big">{Number(score || 0).toFixed(1)}</div>
        <div className="small">/ {max}</div>
      </div>
    </div>
  );
}
